import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class ZIndex extends BaseOption {
  static userInterfaceComponent = {
    label: "Z Index",
    component: inspectorTools.SIMPLE_INPUT,
    props: {
      inputType: "number",
    },
  };

  static defaultValue = 0;
}
